module.exports = __webpack_public_path__ + "img/bb-logo-icon.b226517b.svg";